/**
 * Pet Mindful · Hero por necesidad
 *
 * El selector Perro/Gato no recarga la página: reescribe el tag de especie en
 * el enlace de cada chip, para que la colección abra ya filtrada. La elección
 * se recuerda en la sesión, así el visitante no la repite al volver.
 *
 * Va por tags y no por metafield porque el filtrado por tag es nativo de
 * Shopify y no depende de la indexación de Search & Discovery.
 */
const PM_SPECIES_KEY = 'pm-species';

class PMHero extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[data-pm-species]'));
    this.links = Array.from(this.querySelectorAll('[data-pm-need-link]'));

    this.options.forEach((option) => {
      option.addEventListener('click', () => this.select(option.dataset.pmSpecies));
    });

    this.select(this.remembered() || this.current() || 'perro', { silent: true });
  }

  remembered() {
    try {
      return sessionStorage.getItem(PM_SPECIES_KEY);
    } catch (error) {
      // Modo privado o cookies bloqueadas: seguimos sin memoria.
      return null;
    }
  }

  current() {
    const active = this.options.find((o) => o.getAttribute('aria-pressed') === 'true');
    return active ? active.dataset.pmSpecies : null;
  }

  select(species, options = {}) {
    if (!species) return;

    this.options.forEach((option) => {
      option.setAttribute('aria-pressed', String(option.dataset.pmSpecies === species));
    });

    this.links.forEach((link) => this.applySpecies(link, species));

    if (!options.silent) {
      try {
        sessionStorage.setItem(PM_SPECIES_KEY, species);
      } catch (error) {
        /* sin memoria, pero el filtro igual se aplica */
      }
    }
  }

  applySpecies(link, species) {
    // base recuerda el href original, para no encadenar tags al alternar
    if (!link.dataset.pmBase) link.dataset.pmBase = link.getAttribute('href') || '';
    const base = link.dataset.pmBase;
    if (!base) return;

    // Shopify filtra por tag con /collections/<handle>/<tag>+<tag>
    const match = base.match(/^(\/collections\/[^/?#]+)(?:\/([^?#]*))?/);
    if (!match) return;

    const tags = (match[2] || '').split('+').filter((t) => t && t !== 'perro' && t !== 'gato');
    tags.push(species);
    link.setAttribute('href', `${match[1]}/${tags.join('+')}`);
  }
}

if (!customElements.get('pm-hero')) {
  customElements.define('pm-hero', PMHero);
}
